var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188.967,
    height: 145.566,
    viewBox: "0 0 188.967 145.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_7645",
    x: 0,
    y: 0,
    width: 188.967,
    height: 145.566,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EmailSentDark",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    d: "M880.375,405.238l18.954,34.044L918.97,417.76l77.392-97.817L877.721,402.89Z",
    transform: "translate(-832.452 -309.253)",
    fill: "#56aa1c",
    stroke: "#5b5c5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -4)",
    filter: "url(#Path_7645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7645-2",
    "data-name": "Path 7645",
    d: "M1025.657,310.176l0-.019.005-.024c0-.019,0-.04,0-.06a2.4,2.4,0,0,0,.017-.261l0-.027c0-.04,0-.078-.008-.116a.5.5,0,0,0,0-.051l0-.044c-.006-.041-.014-.081-.022-.121l-.008-.043c-.008-.037-.017-.072-.029-.107,0-.019-.01-.038-.016-.056-.014-.046-.03-.092-.049-.138-.008-.022-.016-.046-.026-.068-.017-.04-.04-.076-.059-.115s-.027-.064-.044-.094-.025-.033-.038-.052-.033-.054-.052-.081l-.016-.027c-.017-.024-.04-.041-.059-.065a.964.964,0,0,0-.073-.089c-.019-.022-.038-.046-.059-.067l-.025-.03c-.013-.011-.025-.019-.038-.029l-.029-.024,0,0a1.85,1.85,0,0,0-.207-.162l-.059-.038c-.041-.025-.079-.056-.122-.078s-.07-.019-.105-.033a1.812,1.812,0,0,0-.184-.07c-.057-.019-.115-.032-.173-.046l-.008,0c-.064-.013-.123-.032-.186-.04a1.963,1.963,0,0,0-.555,0l-.016,0a1.833,1.833,0,0,0-.515.146L849.856,388.57a1.954,1.954,0,0,0-1.13,1.917,1.974,1.974,0,0,0,1.385,1.744l43.263,13.258,19.659,34.952c.014.029.038.049.054.076a2.051,2.051,0,0,0,.191.258c.029.032.057.064.089.094a1.834,1.834,0,0,0,.258.213c.027.021.054.041.083.06a2.026,2.026,0,0,0,.369.18l.03.013.018.008c.024.008.049,0,.072.011a2.026,2.026,0,0,0,.378.083c.057,0,.116.008.173.008a1.961,1.961,0,0,0,.544-.087,1.39,1.39,0,0,0,.138-.046,2,2,0,0,0,.407-.208c.024-.016.051-.027.076-.044a2.122,2.122,0,0,0,.339-.315l18.877-22.458L998.3,437.65a2,2,0,0,0,.574.084,1.966,1.966,0,0,0,1.93-1.585l24.84-125.9c0-.024.008-.049.013-.073Zm-169.5,79.8,150.1-69.848L894.337,401.672Zm150.006-64.915L922.2,411.33a1.954,1.954,0,0,0-.284.383c-.024.041-.038.086-.059.129a1.915,1.915,0,0,0-.11.24l-7.47,22.558L897.27,404.4Zm-81.29,90.084,6.173,1.89-11.217,13.346Zm2.391-3.378,28.167-28.943,65.084-66.875L997.37,433.252Z",
    transform: "translate(-842.72 -303.88)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7646",
    "data-name": "Path 7646",
    d: "M896.978,411.667l99.449-103.552L970.684,435.852Z",
    transform: "translate(-820.262 -307.738)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7647",
    "data-name": "Path 7647",
    d: "M893.712,403.154l-43.1-13.04,171.756-81.075Z",
    transform: "translate(-847.608 -307.194)",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/EmailSent.c6cfa315f256cc430ac6e30c314cfd00.svg";
export { ForwardRef as ReactComponent };